export const mx = {
  sodimac: {
    colorGroupMapping: {},
    textDictionary: {},
    toggles: {},
    endpoints: {},
    facetLabels: {},
    configurations: {},
  },
  so_retail: {
    colorGroupMapping: {},
    textDictionary: {},
    toggles: {},
    endpoints: {},
    facetLabels: {},
    configurations: {},
  },
};
